$ = require 'jquery'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
popoverShare = require 'app/scripts/views/templates/popover_share'
{ track } = require '@trello/analytics'
{ dontUpsell } = require '@trello/config'
Controller = require 'app/scripts/controller'
Auth = require 'app/scripts/db/auth'
print = require('app/common/lib/util/print').default

module.exports = class SharePopoverView extends View
  viewTitleKey: 'print and export'

  events:
    'click .js-print': 'printModel'
    'click .js-export-json': 'exportJSON'
    'click .js-export-csv': 'exportCSV'
    'click a[href="/business-class"]': 'businessClass'
    'click .js-upgrade': 'upgrade'
    'click .js-learn-more': 'learnMore'
    'click .js-add-to-team': 'addToTeam'
    'click .js-close-ad': 'closeAd'

  render: ->
    view = @
    org = @model.getOrganization()

    data = @model.toJSON()
    data.hasCsvExport = false

    data.hasOrganization = @model.hasOrganization()
    data.upgradeUrl = Controller.getUpgradeUrl(@model)
    data.isAdDismissed = Auth.me().isAdDismissed('share-popover')

    if org? && org?.isFeatureEnabled('csvExport')
      data.hasCsvExport = true
      data.csvURL = "/b/#{ @model.get('shortLink') }.csv"

    if org?.isPremium() && !org?.isFeatureEnabled('csvExport')
      data.needsUpgradeForCsv = true

    data.jsonURL = "/b/#{ @model.get('shortLink') }.json"

    data.upsellEnabled = !dontUpsell

    @$el.html(popoverShare(data))

    @

  printModel: (e) ->
    Util.stop(e)

    track("Board Menu", "Print and Export Menu", "Print")
    PopOver.hide()

    @defer ->
      print()

    return

  exportJSON: (e) ->
    track("Board Menu", "Print and Export Menu", "Export JSON")

  exportCSV: (e) ->
    track("Board Menu", "Print and Export Menu", "Export CSV")

  businessClass: (e) ->
    track("Board Menu", "Print and Export Menu", "Click Business Class Link")

  upgrade: (e) ->
    track("Board Menu", "Print and Export Menu", "Upgrade Button")

  learnMore: (e) ->
    track("Board Menu", "Print and Export Menu", "Clicks Learn More Link")

  addToTeam: (e) ->
    Util.stop(e)
    PopOver.hide()
    @model.trigger 'add-to-team'

  closeAd: (e) ->
    Util.stop(e)
    @$('.popover-share-ads-container').remove()
    Auth.me().dismissAd('share-popover')
